export default __webpack_public_path__ + "static/media/About_Landing-08.ac390c0d.png";